// src/forensics/checks.generated.json
var checks_generated_default = {
  checks: [
    {
      claims: [
        "entity",
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Every payment it receives is forwarded, within minutes, to one exchange.",
      families: [
        "evm"
      ],
      id: "evm.exchange_deposit_address",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        forward_ratio: {
          default: 0.9,
          high: 1,
          integer: false,
          low: 0.5,
          unit: "ratio"
        },
        max_dwell_seconds: {
          default: 604800,
          high: 7776e3,
          integer: true,
          low: 60,
          unit: "seconds"
        },
        min_sweeps: {
          default: 2,
          high: 1e3,
          integer: true,
          low: 2,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_deposit_address",
      subject: "address",
      tags: [
        {
          name: "exchange-deposit-address",
          severity: null,
          title: "Exchange deposit address"
        }
      ],
      title: "Exchange deposit address",
      trust: 0.85
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "A lookalike of a wallet its victims really pay, planting bait in their history.",
      families: [
        "evm"
      ],
      id: "evm.address_poisoning",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_shared_prefix: {
          default: 3,
          high: 20,
          integer: true,
          low: 3,
          unit: "count"
        },
        min_shared_suffix: {
          default: 4,
          high: 20,
          integer: true,
          low: 3,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_address_poisoning",
      subject: "address",
      tags: [
        {
          name: "address_poisoning",
          severity: "high",
          title: "Address poisoning"
        }
      ],
      title: "Address poisoning",
      trust: 0.85
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Who first funded the address \u2014 an exchange withdrawal is a KYC lead; a mixer is a warning.",
      families: [
        "evm"
      ],
      id: "evm.funding_source",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_funding_source",
      subject: "address",
      tags: [
        {
          name: "funded-by-exchange",
          severity: null,
          title: "Funded by an exchange"
        },
        {
          name: "funded-by-bridge",
          severity: null,
          title: "Funded through a bridge"
        },
        {
          name: "funded-by-mixer",
          severity: "medium",
          title: "Funded from a mixer"
        },
        {
          name: "funded-by-sanctioned",
          severity: "high",
          title: "Funded by a sanctioned address"
        }
      ],
      title: "Funding source",
      trust: 0.8
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Forwards nearly everything it receives within minutes to wallets that are not exchanges.",
      families: [
        "evm"
      ],
      id: "evm.pass_through",
      lanes: [
        "research"
      ],
      params: {
        forward_ratio: {
          default: 0.9,
          high: 1,
          integer: false,
          low: 0.5,
          unit: "ratio"
        },
        max_dwell_seconds: {
          default: 86400,
          high: 7776e3,
          integer: true,
          low: 0,
          unit: "seconds"
        },
        min_forwards: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_pass_through",
      subject: "address",
      tags: [
        {
          name: "pass-through",
          severity: "low",
          title: "Pass-through wallet"
        }
      ],
      title: "Pass-through wallet",
      trust: 0.6
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Which protocols it used, read from its own transfers against our protocol address books.",
      families: [
        "evm"
      ],
      id: "evm.protocol_usage",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_protocol_usage",
      subject: "address",
      tags: [
        {
          name: "mixer-user",
          severity: "medium",
          title: "Used a mixer"
        },
        {
          name: "bridge-user",
          severity: null,
          title: "Used a bridge"
        }
      ],
      title: "Protocol, mixer and bridge usage",
      trust: 0.8
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "What its code says it is: a plain wallet, a Safe, a minimal proxy, an EIP-7702 delegated account.",
      families: [
        "evm"
      ],
      id: "evm.account_type",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_account_type",
      subject: "address",
      tags: [
        {
          name: "smart-account",
          severity: null,
          title: "Smart account"
        },
        {
          name: "eip7702-delegated",
          severity: null,
          title: "EIP-7702 delegated account"
        }
      ],
      title: "Account type",
      trust: 0.9
    },
    {
      claims: [
        "entity",
        "label"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A contract a known protocol factory created \u2014 a Uniswap pair, a Safe \u2014 named after it.",
      families: [
        "evm"
      ],
      id: "evm.factory_instance",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_factory_instance",
      subject: "address",
      tags: [],
      title: "Factory-created contract",
      trust: 0.9
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A token calling itself by a registered asset's symbol or name (USDT, USDC, ETH) that it is not.",
      families: [
        "evm"
      ],
      id: "evm.counterfeit_token",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_counterfeit_token",
      subject: "token",
      tags: [
        {
          name: "counterfeit-token",
          severity: "high",
          title: "Counterfeit token"
        }
      ],
      title: "Counterfeit token",
      trust: 0.9
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "A token pushed onto wallets that never asked for it: airdropped dust, a counterfeit, a provider's spam flag.",
      families: [
        "evm"
      ],
      id: "evm.spam_token",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_batch_recipients: {
          default: 10,
          high: 1e4,
          integer: true,
          low: 2,
          unit: "count"
        },
        min_signals: {
          default: 2,
          high: 3,
          integer: true,
          low: 2,
          unit: "count"
        },
        min_unsolicited_recipients: {
          default: 20,
          high: null,
          integer: true,
          low: 1,
          unit: "count"
        }
      },
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_spam_token",
      subject: "token",
      tags: [
        {
          name: "spam-token",
          severity: "low",
          title: "Spam token"
        }
      ],
      title: "Spam token",
      trust: 0.85
    },
    {
      claims: [],
      cost: "cheap",
      default_enabled: true,
      description: "How much of what it received came straight from exchanges, mixers, bridges or sanctioned addresses.",
      families: [
        "evm"
      ],
      id: "evm.exposure",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic"
      ],
      source_id: "forensic_exposure",
      subject: "address",
      tags: [],
      title: "Direct exposure",
      trust: 0.8
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Automated trading: a sustained burst of swaps through DEX routers, builder tips, no idle hours.",
      families: [
        "evm"
      ],
      id: "evm.trading_bot",
      lanes: [
        "research"
      ],
      params: {
        min_active_hours: {
          default: 18,
          high: 24,
          integer: true,
          low: 1,
          unit: "count"
        },
        min_swaps: {
          default: 50,
          high: 1e5,
          integer: true,
          low: 10,
          unit: "count"
        },
        min_swaps_per_hour: {
          default: 30,
          high: 1e5,
          integer: true,
          low: 10,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_trading_bot",
      subject: "address",
      tags: [
        {
          name: "trading-bot",
          severity: null,
          title: "Trading bot"
        }
      ],
      title: "Trading bot",
      trust: 0.6
    },
    {
      claims: [
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "Pulls tokens out of many unrelated wallets with approvals they granted \u2014 a phishing drainer's shape.",
      families: [
        "evm"
      ],
      id: "evm.drainer",
      lanes: [
        "research"
      ],
      params: {
        min_victims: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_drainer",
      subject: "address",
      tags: [
        {
          name: "drainer",
          severity: "critical",
          title: "Drainer"
        }
      ],
      title: "Drainer",
      trust: 0.6
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Claims airdrops from many distributors and passes them on to one collector.",
      families: [
        "evm"
      ],
      id: "evm.airdrop_farmer",
      lanes: [
        "research"
      ],
      params: {
        min_claims: {
          default: 5,
          high: 1e3,
          integer: true,
          low: 3,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_airdrop_farmer",
      subject: "address",
      tags: [
        {
          name: "airdrop-farmer",
          severity: "low",
          title: "Airdrop farmer"
        }
      ],
      title: "Airdrop farmer",
      trust: 0.6
    },
    {
      claims: [
        "entity",
        "label",
        "tag"
      ],
      cost: "heavy",
      default_enabled: true,
      description: "Receives sweeps from many deposit-shaped addresses \u2014 an exchange or custodian hot wallet.",
      families: [
        "evm"
      ],
      id: "evm.consolidation_wallet",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        max_shared_funder_share: {
          default: 0.5,
          high: 0.5,
          integer: false,
          low: 0.1,
          unit: "ratio"
        },
        min_deposit_senders: {
          default: 3,
          high: 1e3,
          integer: true,
          low: 2,
          unit: "count"
        }
      },
      profiles: [
        "forensic"
      ],
      source_id: "forensic_consolidation_wallet",
      subject: "address",
      tags: [
        {
          name: "consolidation-wallet",
          severity: null,
          title: "Consolidation (hot) wallet"
        }
      ],
      title: "Consolidation wallet",
      trust: 0.85
    },
    {
      claims: [
        "label"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "The ENS name the address declares as its own \u2014 its primary name, verified both ways.",
      families: [
        "evm"
      ],
      id: "evm.ens_name",
      lanes: [
        "research"
      ],
      params: {},
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_ens_name",
      subject: "address",
      tags: [],
      title: "ENS name",
      trust: 0.85
    },
    {
      claims: [
        "tag"
      ],
      cost: "cheap",
      default_enabled: true,
      description: "Deployed contracts the catalog calls counterfeit tokens, spam tokens or drainers.",
      families: [
        "evm"
      ],
      id: "evm.scam_deployer",
      lanes: [
        "pipeline",
        "research"
      ],
      params: {
        min_scam_contracts: {
          default: 1,
          high: 100,
          integer: true,
          low: 1,
          unit: "count"
        },
        min_without_counterfeit: {
          default: 2,
          high: 100,
          integer: true,
          low: 2,
          unit: "count"
        }
      },
      profiles: [
        "forensic",
        "standard"
      ],
      source_id: "forensic_scam_deployer",
      subject: "address",
      tags: [
        {
          name: "scam-deployer",
          severity: "high",
          title: "Scam deployer"
        }
      ],
      title: "Scam deployer",
      trust: 0.85
    }
  ]
};

// src/forensics/checks.ts
var FORENSIC_PROFILES = ["standard", "forensic"];
var FORENSIC_LANES = ["research", "pipeline"];
var FORENSIC_LANE_LABELS = Object.freeze({
  research: "Research",
  pipeline: "Automatic"
});
function isForensicLane(value) {
  return typeof value === "string" && FORENSIC_LANES.includes(value);
}
function forensicLanesLabel(lanes) {
  const known = FORENSIC_LANES.filter((lane) => lanes.includes(lane));
  if (known.length === 0) return "Nowhere";
  if (known.length === 1) return `${FORENSIC_LANE_LABELS[known[0]]} only`;
  const [first, ...rest] = known.map(
    (lane, i) => i === 0 ? FORENSIC_LANE_LABELS[lane] : FORENSIC_LANE_LABELS[lane].toLowerCase()
  );
  return `${first} and ${rest.join(" and ")}`;
}
var SPANS = [
  [86400, "day"],
  [3600, "hour"],
  [60, "minute"],
  [1, "second"]
];
function forensicParamText(value, param) {
  if (!Number.isFinite(value)) return String(value);
  if (param.unit === "seconds") {
    if (value === 0) return "0 seconds";
    for (const [size, word] of SPANS) {
      if (value % size === 0) {
        const n = value / size;
        return `${n} ${word}${n === 1 ? "" : "s"}`;
      }
    }
    return `${value} seconds`;
  }
  if (param.unit === "ratio") return `${Number((value * 100).toFixed(2))}%`;
  return String(value);
}
var FORENSIC_CHECKS = Object.freeze(
  checks_generated_default.checks.map(
    (c) => Object.freeze({ ...c, params: Object.freeze({ ...c.params }) })
  )
);
var BY_ID = new Map(FORENSIC_CHECKS.map((c) => [c.id, c]));
function forensicCheck(id) {
  return BY_ID.get(id);
}
function isForensicProfile(value) {
  return typeof value === "string" && FORENSIC_PROFILES.includes(value);
}
function requireForensicParam(checkId, name) {
  const param = forensicCheck(checkId)?.params[name];
  if (!param) {
    throw new Error(
      `${checkId} declares no param ${JSON.stringify(name)} in the forensic check snapshot \u2014 regenerate checks.generated.json (pnpm gen:types) or fix the reader`
    );
  }
  return param;
}
function forensicParamOverride(param, raw) {
  if (raw === null || raw === void 0 || typeof raw === "boolean") return null;
  const value = typeof raw === "number" ? raw : typeof raw === "string" && raw.trim() !== "" ? Number(raw) : Number.NaN;
  if (!Number.isFinite(value)) return null;
  const honoured = param.integer ? Math.trunc(value) : value;
  if (honoured < param.low || param.high !== null && honoured > param.high) return null;
  return honoured;
}
function resolveForensicParams(checkId, overrides) {
  const check = forensicCheck(checkId);
  if (!check) return {};
  const out = {};
  for (const [name, param] of Object.entries(check.params)) {
    out[name] = forensicParamOverride(param, overrides?.[name]) ?? param.default;
  }
  return out;
}
function clampForensicParam(param, value) {
  const whole = param.integer ? Math.trunc(value) : value;
  const floor = Math.max(param.low, whole);
  return param.high === null ? floor : Math.min(param.high, floor);
}
function isRecord(value) {
  return value !== null && typeof value === "object" && !Array.isArray(value);
}
function forensicChecksPolicyOf(policy) {
  const section = isRecord(policy) ? policy.forensic_checks : void 0;
  return isRecord(section) ? section : {};
}
function forensicCheckEnabled(policy, checkId) {
  const check = forensicCheck(checkId);
  if (!check) return false;
  const enabled = policy?.[checkId]?.enabled;
  return typeof enabled === "boolean" ? enabled : check.default_enabled;
}
function forensicLaneNarrowedAway(policy, checkId, lane) {
  const lanes = policy?.[checkId]?.lanes;
  return Array.isArray(lanes) && !lanes.includes(lane);
}
function forensicCheckParams(policy, checkId) {
  const raw = policy?.[checkId]?.params;
  return resolveForensicParams(checkId, isRecord(raw) ? raw : void 0);
}
function forensicChecksForProfile(profile, policy) {
  return FORENSIC_CHECKS.filter((c) => c.profiles.includes(profile) && runsInResearch(policy, c.id));
}
function runsInResearch(policy, checkId) {
  return forensicCheckEnabled(policy, checkId) && !forensicLaneNarrowedAway(policy, checkId, "research");
}
function forensicChecksOffByPolicy(profile, policy) {
  return FORENSIC_CHECKS.filter(
    (c) => c.profiles.includes(profile) && c.default_enabled && !runsInResearch(policy, c.id)
  );
}
function defaultForensicCheckIds(profile, policy) {
  return forensicChecksForProfile(profile, policy).map((c) => c.id);
}
function isHeavyForensicCheck(check) {
  return check.cost === "heavy";
}
function forensicChecksToRequest(profile, picked, policy) {
  const chosen = new Set(picked);
  const defaults = defaultForensicCheckIds(profile, policy);
  const selection = defaults.filter((id) => chosen.has(id));
  const same = selection.length === defaults.length && selection.every((id, i) => id === defaults[i]);
  return same ? void 0 : selection;
}
function forensicSelectionIsEmpty(profile, picked, policy) {
  const chosen = new Set(picked);
  return !forensicChecksForProfile(profile, policy).some((c) => chosen.has(c.id));
}

export { FORENSIC_CHECKS, FORENSIC_LANES, FORENSIC_LANE_LABELS, FORENSIC_PROFILES, clampForensicParam, defaultForensicCheckIds, forensicCheck, forensicCheckEnabled, forensicCheckParams, forensicChecksForProfile, forensicChecksOffByPolicy, forensicChecksPolicyOf, forensicChecksToRequest, forensicLaneNarrowedAway, forensicLanesLabel, forensicParamOverride, forensicParamText, forensicSelectionIsEmpty, isForensicLane, isForensicProfile, isHeavyForensicCheck, requireForensicParam, resolveForensicParams };
//# sourceMappingURL=chunk-O3OIBNP7.js.map
//# sourceMappingURL=chunk-O3OIBNP7.js.map